import { render, staticRenderFns } from "./CoordinationEventSettingsCreate.vue?vue&type=template&id=bd4107a6&scoped=true"
import script from "./CoordinationEventSettingsCreate.vue?vue&type=script&lang=ts"
export * from "./CoordinationEventSettingsCreate.vue?vue&type=script&lang=ts"
import style0 from "./CoordinationEventSettingsCreate.vue?vue&type=style&index=0&id=bd4107a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4107a6",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/views/client-settings/coordination/event/coordination-event-settings-create.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fviews%2Fclient-settings%2Fcoordination%2Fevent%2FCoordinationEventSettingsCreate.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports